import { render, staticRenderFns } from "./CopiaDdt.vue?vue&type=template&id=08621adf"
import script from "./CopiaDdt.vue?vue&type=script&lang=js"
export * from "./CopiaDdt.vue?vue&type=script&lang=js"
import style0 from "./CopiaDdt.vue?vue&type=style&index=0&id=08621adf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports